module.exports = __webpack_public_path__ + "static/media/vocals-course.fbc034cd.jpg";